import React from 'react';
import { Typography } from '@mui/material';
import { List } from 'components/common/List';
import { Container } from 'shared-components/Container';

const mostFrequentlyDiscussed = [
  'Understanding PKD',
  'Available treatment options',
  'Emotional support',
  'Online community connections',
  'Getting connected with a PKD Connect peer mentor',
  'Education webinars',
];

export const AboutFoundation = () => (
  <Container
    maxWidth={{ xl: '800px' }} mb={4}>
    <Typography
      fontFamily='Montserrat' fontWeight='700' variant='h6' mb={4}>
      About the Foundation
    </Typography>
    <Typography
      variant='body2' mb={2}>
      We are the only organization in the U.S. solely dedicated to finding
      treatments and a cure for polycystic kidney disease (PKD). We fund
      research, education, advocacy, support, and awareness on a national and
      local level.
    </Typography>
    <Typography
      variant='body2' mb={2}>
      <strong>Do you have questions about PKD?</strong> Call the PKD HOPE line
      today.
    </Typography>
    <Typography
      variant='body2' mb={2}>
      Connect with our support team by dialing 844-PKD-HOPE (844-753-4673). Our
      team is available Monday through Friday from 8 a.m. - 5 p.m. Central time
      to answer your questions and direct you to resources that will address
      your concerns. If you call after hours, please leave us a message and we
      will get back to you as soon as possible. Whether you or a loved one have
      been recently diagnosed with PKD, or if you are looking for ongoing
      support PKD Connect staff is here to help.
    </Typography>
    <Typography
      variant='body2' mb={2}>
      Topics most frequently discussed:
    </Typography>
    <List>
      {mostFrequentlyDiscussed.map((item) => (
        <List.Item
          key={item}>{item}</List.Item>
      ))}
    </List>
  </Container>
);
